<h1 mat-dialog-title>
	<span [cmLocalize]="locFeature + '/_View.Timeout.Title.Modal'">Your Session is About to End</span>
</h1>
<div mat-dialog-content class="mb-16">
	<p><span [cmLocalize]="locFeature + '/_View.Timeout.Content.Modal'">
			You've been inactive for a while. For your security, we'll automatically sign you out in approximately 3
			minutes. You may choose "Stay signed in" to continue or "Sign out" if you're done.
		</span></p>
</div>

<div mat-dialog-actions>
	<button [mat-dialog-close]="false">
		<span [cmLocalize]="locFeature + '/_View.Timeout.Button.Leave'">Sign out</span>
	</button>
	<button [mat-dialog-close]="true" color="primary" cdkFocusInitial>
		<span [cmLocalize]="locFeature + '/_View.Timeout.Button.Stay'">Stay signed in</span>
	</button>
</div>
